<template>

    <v-autocomplete
      v-model="select"
      :loading="isLoading"
      :items="items"
      :search-input.sync="searchInput"
      class="mx-3 global-search"
      flat
      :filter="v => v"
      :hide-details="hideDetails"
      single-line
      hide-no-data
      :label="`Search ${searchObj[searchIndex].name}`"
      :solo-inverted = "solo"
      prepend-inner-icon="search"
      return-object
      dense
      @change="go"
      append-icon=""
      id="help"
      @blur="reset"
      hideDetails
    >
        <v-slide-x-transition
          slot="prepend-inner"
          mode="out-in"
        >
          <!-- <v-icon
            :key="`icon-${isBooking}`"
            @click="isBooking = !isBooking"
            v-text="isBooking ? 'assignment' : 'search'"
          ></v-icon> -->
          <v-icon
            :key="`icon-${searchIndex}`"
            @click="changeSearch"
            v-text="searchObj[searchIndex].icon"
          ></v-icon>
        </v-slide-x-transition>
    <div
        slot="prepend-item"
        class="px-3 grey--text">
      items found: {{ items.length }}
    </div>

      <template no-filter v-slot:item="{ item }">
        <v-list-item-avatar>
          <v-icon v-if="item.route==='client'">person</v-icon>
          <v-icon v-else-if="item.route==='destination'">domain</v-icon>
          <v-icon v-else-if="item.route==='booking'">assignment</v-icon>
          <v-icon v-else-if="item.route.indexOf('invoice') != - 1">euro_symbol</v-icon>
        </v-list-item-avatar>

        <v-list-item-content v-if="item.route==='booking'">
          <v-list-item-title> Booking: {{ item.id }} - {{ item.date }} {{ item.time | formatTime }}</v-list-item-title>
          <v-list-item-subtitle> Traject: {{ item.client }} - {{ item.destination }} </v-list-item-subtitle>
          <v-list-item-subtitle> Driver: {{ item.driver }}  - <strong>{{ item.price_driver | currency }}</strong></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content v-else-if="item.route.indexOf('invoice') != - 1">
          <v-list-item-title >
            Invoice: {{ item.id }} - {{ item.date }}  -
            <span :class="'invoice status-' + item.status">
              {{ item.amount | currency }}
            </span>
            <v-icon v-if="item.status === 1">check</v-icon>
          </v-list-item-title>
          <v-list-item-subtitle>Client: {{ item.name }} </v-list-item-subtitle>
          <v-list-item-subtitle v-if="item.invoiceAddress">Address: {{ item.invoiceName }} - {{ item.invoiceAddress }}</v-list-item-subtitle>
          <v-list-item-subtitle v-else>Address: {{ item.address }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content v-else>
          <v-list-item-title v-if="item.name"> {{ item.name }} <span v-if="item.tel"> - tel: {{ item.tel }}</span></v-list-item-title>
          <v-list-item-title v-else>
            {{ item.firstname }} {{ item.lastname }} <v-icon v-if="item.problem === 1" small color="red">error</v-icon> <span v-if="item.tel"> - tel: {{ item.tel }}</span>
          </v-list-item-title>
          <v-list-item-subtitle v-html="item.fullAddress"></v-list-item-subtitle>
        </v-list-item-content>
      </template>


              </v-autocomplete>
</template>
<script>
  import moment from 'moment';
  export default {
    props: {
      global: {
        type: Boolean,
        default: false
      },
      solo: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        items: [],
        select: null,
        query: '',
        searchObj: [
          {icon: 'search', name: '', index: 'places'},
          {icon: 'assignment', name: 'bookings', index: 'bookings'},
          {icon: 'euro_symbol', name: 'invoices', index: 'invoices'}
        ],
        searchIndex: 0,
        isBooking: null
      }
    },
    methods: {
      go (item) {
        // console.log('go', item);
        if (this.$route.name !== item.route && this.global) {
          console.log('go route', item);
          this.$router.push({ name: item.route, params: { item: item } })
        } else {
          console.log('go emit', item);
          this.$bus.$emit('search:show', item);
          this.$nextTick(() => {
            this.reset()
          })
        }
      },
      changeSearch () {
        this.searchIndex++;
        if (this.searchIndex > this.searchObj.length - 1) {
          this.searchIndex = 0
        }
        this.query = '';
      },
      reset () {
        // console.log('on blur ');
        this.select = null;
        this.items = [];
      },
      hasIndex (v) {
        var result = {};
        var search;
        if (typeof v === 'string' || v instanceof String) {
          search = (this.searchObj && this.searchIndex && this.searchObj[this.searchIndex]) || {index: '_all'}
          result = {
            q: v,
            index: search.index
          }
        }
        return result
      },
      search: function (r) {
        if ((typeof r.q === 'string' || r.q instanceof String) && r.q !== '') {
          this.isLoading = true
          this.$http
          .post('service/search/all', r)
          .then(response => {
            this.isLoading = false;
            if (response.data.hits && response.data.hits.hits) {
              this.items = response.data.hits.hits.map(hit => { return hit._source });
              console.log('search:', response.data);
            }
          })
        }
      }
    },
    computed: {
      searchInput: {
        get: () => '',
        set: function (v) {
          this.query = (typeof v === 'string') ? v : '';
        }
      }
    },
    // declare Vue watchers
    watch: {
      // watch for change in the query string and recall the search method
      query: function (v) {
        var r = this.hasIndex(v)
        if (r.q) {
          this.search(r);
        } else {
          this.reset();
        }
      }
    },
    filters: {
      date: function (date) {
        return moment(date).format('DD/MM/YYYY');
      }
    }
  }
</script>
<style lang="scss">

    .v-autocomplete__content {
      .v-list__item, .v-list--dense .v-list__item:not(.v-list__item--avatar) {
        height: auto;
        padding: 5px 16px;
      }
      div[role=listitem] {
        .v-list__item__title {
          color: rgba(0,0,0,.87);
          height: auto;
          line-height: inherit;
        }
      }
    }
    .v-autocomplete.v-input--is-focused {
      .v-input__prepend-inner .theme--dark.v-icon {
        color: #e5332a;
      }
    }
  .grey-line {
    border-top: solid 1px #b9b8b8;
  }
  .invoice.status {
    text-transform: none;
    &-0 {
      color:rgba(248, 1, 1, 1) !important;
    }
    &-1 {
      color:rgba(32, 151, 2, 1) !important;
    }
    &-2 {
      color:rgba(248, 1, 1, 1) !important;
    }
}

</style>

